import ApiBase from 'Services/Api/ApiBase';

class TimesheetRates extends ApiBase {
    route = '/admin/human-resources/timesheet-rates';
};

export default new TimesheetRates();